import { Loader2 } from "lucide-react";
import { startedAgoText } from "./helpers";

/** Spinner plus "Testing… (started 2 min ago)". Re-rendered by the overview polling. */
const TestingNote = ({ startedAt }: { startedAt: string | null }) => {
  const ago = startedAgoText(startedAt);
  return (
    <span className="flex items-center gap-1 text-xs text-muted-foreground">
      <Loader2 className="h-3 w-3 animate-spin" aria-hidden="true" />
      <span>{ago ? `Testing… (started ${ago})` : "Testing…"}</span>
    </span>
  );
};

export default TestingNote;
